import { render, staticRenderFns } from "./want-audit.vue?vue&type=template&id=507c7174&scoped=true"
import script from "./want-audit.vue?vue&type=script&lang=js"
export * from "./want-audit.vue?vue&type=script&lang=js"
import style0 from "./want-audit.vue?vue&type=style&index=0&id=507c7174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c7174",
  null
  
)

export default component.exports